import React from "react";
import Svg, { G, Path } from "react-native-svg";

type Avatar23Colors = {
  background?: string;
  skin?: string;
  hair?: string;
};

export const Avatar23 = ({
  colors = {},
  size = 96,
}: {
  colors?: Avatar23Colors;
  size?: number | string;
}) => {
  const c = {
    background: colors.background ?? "#fff",
    skin: colors.skin ?? "#fff",
    hair: colors.hair ?? "#fff",
  };
  return (
    <Svg width={size} height={size} viewBox="0 0 304 304" fill="none">
      <G id="avatar23">
        <G id="Group">
          <Path
            id="background"
            d="M151.833 303.666c83.855 0 151.834-67.978 151.834-151.833S235.688 0 151.833 0 0 67.978 0 151.833s67.978 151.833 151.833 151.833Z"
            fill={c.background}
          />
          <Path
            id="Vector"
            d="M139.727 242.827c-26.714-4.623-77.02 11.415-94.091 17.508 27.381 26.801 64.859 43.332 106.197 43.332 28.327 0 54.835-7.769 77.53-21.273-15.61-11.145-62.27-34.833-89.644-39.567h.008Z"
            fill="#000"
          />
          <Path
            id="skin"
            d="M177.658 58.847c-74.344 0-81.78 19.747-81.78 65.971 0 2.407-.412 1.509-.19 3.996-7.046 0-13.138 14.87-10.048 24.132 7.236 21.702 24.41 22.004 24.752 21.821 2.812 6.395-3.313 47.495-5.171 54.826-3.011 11.836-25.92 21.853-25.92 21.853s50.02 39.44 84.861 51.721a151.333 151.333 0 0 0 25.419-4.234c2.256-10.764-.317-29.344-3.066-33.045-3.916-5.275-10.501-3.623-14.68-10.947-1.771-3.114-.039-22.369.699-35.031 10.033-1.461 20.312 4.536 30.281-5.775 6.546-6.768 17.428-31.829 20.121-46.406 2.193-11.852-.993-14.155-.993-29.415 1.875-41.37-3.114-79.475-44.293-79.475l.008.008Z"
            fill={c.skin}
          />
          <Path
            id="Vector_2"
            d="M135.645 125.302s12.955-3.948 23.036-3.877c11.844.079 20.161 7.761 22.44 3.829.723-1.247.231-7.809-21.352-9.961-9.659-.962-15.339 3.423-24.124 10.009Z"
            fill="#000"
          />
          <Path
            id="Vector_3"
            d="M177.792 141.999c-2.923-4.838-7.761-9.294-13.838-10.375-2.74-.309-5.505-.007-8.11.97-2.129.786-3.773 2.097-5.354 3.399-2.145 1.43-4.981.89-7.554.596 2.43 1.652 6.029 2.971 8.992 1.557a25.12 25.12 0 0 1 2.057-1.16c-.024.207-.048.413-.048.628 0 3.845 3.329 6.958 7.436 6.958 4.106 0 7.435-3.113 7.435-6.958 0-.318-.032-.62-.072-.929 2.916 1.294 5.847 3.209 9.064 5.314h-.008Z"
            fill="#000"
          />
          <Path
            id="Vector_4"
            opacity={0.75}
            d="M199.821 127.629c-.278-.389-.278-1.017.087-1.772-10.152 14.116 3.869 36.819-1.596 41.1-3.821 2.987-18.263-1.191-18.827 2.638 5.259 3.217 19.74 5.783 24.125-1.653 1.716-3.836-9.635-29.383 1.621-40.321-2.137 1.469-4.465 1.311-5.402.016l-.008-.008Z"
            fill="#2E2017"
          />
          <Path
            id="Vector_5"
            opacity={0.75}
            d="M139.322 219.734c14.251 12.082 22.37 15.76 31.56 16.721-.167-7.086 1.661-16.896 1.255-17.031-20.264-6.951-29.081-13.314-45.532-27.374-5.99-5.123-11.375-12.519-16.006-19.271 0 .445.071.977 0 2.622 2.303 9.977 9.039 27.659 28.716 44.349l.007-.016Z"
            fill="#2E2017"
          />
          <Path
            id="Vector_6"
            opacity={0.75}
            d="M164.122 182.941c.882.738 13.186 14.298 26.977 13.806 11.748-.421 15.545-11.574 15.823-12.138 0 0-5.187-4.814-8.801-4.679-3.607.127-6.133 1.851-6.133 1.851s-3.249-1.883-7.085-1.748c-3.837.135-7.245 2.074-10.836 2.661-3.63.588-9.953.247-9.953.247h.008Zm4.965 2.168c-.095-.047-.008-.159.103-.119 4.393 1.525 12.011 2.566 23.823 2.145 6.085-.215 10.104-.405 13.44-1.478-3.32 1.327-7.689 4.902-13.766 5.116-11.836.421-19.247-3.4-23.592-5.664h-.008Z"
            fill="#2E2017"
          />
          <Path
            id="Vector_7"
            d="M222.157 117.613c-14.155-.413-23.854 7.189-22.337 10.017.937 1.747 3.829 1.819 5.958-.151 5.838-4.854 10.374-3.233 16.499-3.313.135-2.001-.096-4.877-.12-6.545v-.008Z"
            fill="#000"
          />
          <Path
            id="Vector_8"
            d="M227.687 136.669c-1.581-1.31-3.217-2.613-5.354-3.4-2.606-.977-5.378-1.279-8.111-.969-6.076 1.081-10.922 5.537-13.837 10.375 1.652-1.081 3.233-2.113 4.766-3.035.286 3.384 3.297 6.045 6.982 6.045 3.869 0 7.014-2.939 7.014-6.561a6.129 6.129 0 0 0-1.016-3.352c2.51.27 5.171 1.215 8.126 3.058 2.955 1.414 6.553.095 8.992-1.557-2.574.286-5.418.834-7.554-.596l-.008-.008Z"
            fill="#000"
          />
          <Path
            id="hair"
            d="M218.893 90.032c.047.66-3.726-3.685-3.909-4.32-1.08-3.758-1.652-8.516-5.743-8.651-7.626-.255-20.589 4.575-20.589 4.575s-7.626-10.168-28.216-5.084-23.131 8.897-23.131 8.897 7.625 10.422 1.525 21.606c-6.101 11.185-16.015 15.252-16.015 15.252l-2.033 24.403-6.101.508s-8.293-18.008-20.24-14.449c-11.947 3.558-9.334 15.776-9.334 15.776S44.08 60.57 127.653 43.245c78.244-16.22 90.088 30.289 91.256 46.78l-.016.007Z"
            fill={c.hair}
          />
        </G>
      </G>
    </Svg>
  );
};
